import React, {useContext, useEffect, useState} from "react";
import "./InvoiceStatementSadanShop.scss"
import Loader from "../Loader";
import _axios from "../../httpService";
import {prefixUrl} from "../../utils/utilsData";
import Select from "react-select";
import {toast} from "react-toastify";
import NewTabulator from "../NewTabulator/NewTabulator";
import tableCalc from "../../utils/tableCalc";
import {useNavigate} from "react-router-dom";
import {SetPrintDataContext} from "../../Pages";

interface YearMonthData {
    year: number;
    month: string[];
}

interface ItemData {
    value: number;
    label: string;
    yearMonth: YearMonthData[];
}


const InvoiceStatement: React.FC = () => {

    const [loader, setLoader] = useState(true)
    const [initialData: ItemData[], setInitialData] = useState([])
    const [sendData, setSendData] = useState({});
    const columns = [

        {
            title: "ردیف",
            field: "row",
            visible: true,
            formatter: tableCalc.persianDigits,
            style: {
                overflow: 'hidden',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            },
        },

        {
            title: "کدعضو",
            field: "memberId",
            visible: true,
            formatter: tableCalc.persianDigits,
            style: {
                overflow: 'hidden',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            },
        },

        {
            title: "مشخصه",
            field: "memberName",
            visible: true,
            style: {
                overflow: 'hidden',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            },
        },
        {
            title: "تعداد",
            field: "count",
            visible: true,
            formatter: tableCalc.separateNumbers,
            style: {
                overflow: 'hidden',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            },
        },
        {
            title: "فاکتور",
            field: "totalPrice",
            visible: true,
            formatter: tableCalc.separateNumbers,
            style: {
                overflow: 'hidden',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            },
        },
    ];
    const [tableData, setTableData] = useState([])
    const setPrint = useContext(SetPrintDataContext);
    const navigateTo = useNavigate()

    useEffect(() => {

        _axios.get(prefixUrl() + "/organizationInvoice/?request=organizationsData").then(res => {
            if (res.status) {
                setInitialData(res.data.data);
                setLoader(false)
            }
        })
    }, []);

    const showButtonHandler = () => {


        _axios.get(prefixUrl() + "/organizationInvoice/?request=transactionsReports&orgId=" + sendData.orgId + "&year=" + sendData.year + "&month=" + sendData.month).then(res => {
            if (res.data.status) {
                let temp = []
                let setRow = 1
                res.data.data.forEach((v) => {
                    v.row = setRow
                    setRow = setRow + 1
                    temp.push(v)
                })
                setTableData(temp);
            } else {
                toast.error(res.data.message)
            }
        })

    }

    const customStyles = {

        control: (provided: Record<string, unknown>) => ({
            ...provided,
            height: 42,
            '&:hover': {
                border: '1px solid #5D70B5',
            },
            '&:focus': {
                border: '1px solid #5D70B5',
            },
        }),

        option: (base, state) => ({
            ...base,
            color: state.isSelected ? "white" : "'#5D70B5'",
            backgroundColor: state.isSelected ? "#5D70B5" : "white",
            padding: ".5rem 3rem .5rem .5rem",
            cursor: "pointer",
            fontsize: '12'
        }),
    };

    const issuingInvoiceHandler = () => {

        _axios.post(prefixUrl() + "/organizationInvoice/?request=invoiceSubmit", {
            orgId: sendData.orgId, year: sendData.year, month: sendData.month, members: tableData
        }).then(res => {
            if (res.data.status) {
                toast.success(res.data.message)
            } else {
                toast.error(res.data.message)

            }

        })
    }

    const handlePrint = () =>{

        _axios.post(prefixUrl() + "/organizationInvoice/?request=invoiceSubmit", {
            orgId: sendData.orgId, year: sendData.year, month: sendData.month, members: tableData
        }).then(res => {
            if (res.data.status) {
                const myData = {...res.data};
                myData.invoiceData = {};
                myData.invoiceData.entityName = ""
                myData.invoiceData.type = "HAVALEANBAR";
                myData.invoiceData = {...myData.invoiceData , ...myData.print}

                setPrint(myData.invoiceData);
                navigateTo("/factorprint");

                // let invoiceData = {}
                // invoiceData = res.data.print
                // setPrint(invoiceData);
                // navigateTo("/factorprint");
                toast.success(res.data.message)
            } else {
                toast.error(res.data.message)

            }

        })

    }

    return loader ? <Loader type={undefined} text={undefined}/> :
        <div className={"main-invoice-statement"}>

            <div className="middle-invoice">
                <div className='select-box-list'>

                    <div className="label-select">
                        <label style={{width: '45px'}} htmlFor="setSendData_factorType">سازمان</label>
                        <Select options={initialData?.organization}
                                styles={customStyles}
                                defaultValue={{label: "انتخاب کنید ...", value: "0"}}
                                onChange={(e) => {
                                    setSendData({...sendData, orgId: e.value})
                                }}/>
                    </div>

                    <div className="label-select">
                        <label htmlFor="year">سال</label>
                        <Select options={initialData?.year}
                                styles={customStyles}
                                defaultValue={{label: "انتخاب کنید ...", value: "0"}}
                                onChange={(e) => {
                                    setSendData({...sendData, year: e.label})
                                }}/>
                    </div>

                    <div className="label-select">
                        <label htmlFor="month">ماه</label>
                        <Select options={initialData?.month}
                                styles={customStyles}
                                defaultValue={{label: "انتخاب کنید ...", value: "0"}}
                                onChange={(e) => {
                                    setSendData({...sendData, month: e.label})
                                }}/>
                    </div>

                    <button
                        onClick={showButtonHandler}
                        className={"button-show"}>
                        نمایش
                    </button>

                </div>

                <div className="table-invoice">
                    {tableData.length > 0 &&
                        <NewTabulator
                            columns={columns}
                            data={tableData}
                            style={{height: "45vh",}}
                            className={"header__color__F1F1F1"}
                        />
                    }
                </div>

            </div>

            <div className={'button-form'}>

                <button
                    onClick={issuingInvoiceHandler}
                    className="button-show">
                    صدور صورتحساب
                </button>

                <button
                    id={"printButton"}
                    className={"button-show empty-bg"}
                    onClick={handlePrint}>
                    صدور صورتحساب و پرینت
                </button>

            </div>

        </div>
}
export default InvoiceStatement;
